import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=28cad4fc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=28cad4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cad4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cad4fc')) {
      api.createRecord('28cad4fc', component.options)
    } else {
      api.reload('28cad4fc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=28cad4fc&scoped=true&", function () {
      api.rerender('28cad4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lxim1T9y6JHr/JS/comp/Voucher.vue"
export default component.exports